import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import type {WhitespacePreference} from '@github-ui/diff-view-settings/components/WhitespacePreferenceFlyout'
import {useComparisonInfoActions, usePullRequestBasePath} from '../stores/selectors'

export type UpdateWhitespacePreferenceMutationResponse = {
  ignoreWhitespace: boolean
  whitespacePreference?: 'always_show' | 'always_hide'
  whitespacePreferenceSource?: 'url' | 'pull_request_override' | 'user_default' | 'product_default'
}

type UpdateWhitespacePreferenceMutationInput =
  | {hideWhitespace: boolean; preference?: never}
  | {hideWhitespace?: never; preference: WhitespacePreference}

export function useUpdateWhitespacePreferenceMutation() {
  const basePath = usePullRequestBasePath()
  const {updateWhitespace} = useComparisonInfoActions()

  return useMutation({
    mutationFn: async ({hideWhitespace, preference}: UpdateWhitespacePreferenceMutationInput) => {
      const apiUrl = `${basePath}/page_data/${PageData.updateWhitespacePreference}`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: preference ? {preference} : {w: hideWhitespace ? 1 : 0},
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UpdateWhitespacePreferenceMutationResponse, {preference}) => {
      // Persistent preferences take effect on reload, not on the currently displayed diff.
      if (!preference) {
        updateWhitespace(data.ignoreWhitespace)
      }
    },
  })
}
